<template>
  <section class="contact-customer">
    <span class="label">Contact Customer</span>
    <div class="btn-list">
      <v-button
        type="warning"
        icon="bell"
        @click="handlerContact(0)">Send Notification</v-button>
      <v-button
        icon="phone"
        type="success"
        @click="handleCall">Call Customer</v-button>
      <v-button
        type="success"
        icon="comment"
        @click="handlerContact(1)">Send SMS</v-button>
      <v-button
        type="success"
        iconType="fab"
        icon="whatsapp"
        @click="handlerContact(2)"
      >Send WhatsApp</v-button>
      <v-button 
        icon="envelope"
        type="primary"
        @click="handlerContact(3)">Send Email</v-button> 
    </div>
    <contact-dialog
      ref="contact-dialog"
      :type="contactType"
      :ticketId="ticketId"
      :initPhone="phone"
      :initEmail="email"
      :initCustomerName="customerName"
      :customerData="customerData"
      :initCustomerId="customerId"
      @success="handlerSuccess" />
  </section>
 
</template>
<script>
import ContactDialog from '@/views/tickets/dialogs/contact-dialog'
export default {
  name: 'ContactCustomer',
  components: {
    ContactDialog
  },
  props: {
    ticketId: {
      type: [String, Number],
      default: ''
    },
    phone: {
      type: String,
      default: ''
    },
    email: {
      type: String,
      default: ''
    },
    customerName: {
      type: String,
      default: ''
    },
    customerId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      contactType: 0
    }
  },
  computed:{
    customerData(){
      return{
        contact_phone:this.phone,
        contact_email:this.email
      }
    }
  },
  methods: {
    handlerContact(type) {
      this.contactType = type
      this.$refs['contact-dialog'].changeDialog()
    },
    handlerSuccess() {
      this.$emit('success')
    },
    handleCall(){
      const elink = document.createElement('a')
      elink.style.display = 'none'
      elink.href = 'tel:' + this.phone
      document.body.appendChild(elink)
      elink.click()
      window.URL.revokeObjectURL(elink.href)
      document.body.removeChild(elink)
    }
  }
}
</script>
<style lang="scss" scoped>
.btn-list {
        .el-button {
          display: block;
          margin: 0 0 5px 0;
        }
      }
      .label {
        display: inline-block;
        margin: 0 0 5px 0;
        font-size: 14px;
        font-weight: bold;
      }
</style>